import variables from '@/styles/element-variables.scss'
import defaultSettings from '@/settings'
import { view, secureView, basicView } from '@/api/setting'
import { postUserConfig } from '@/api/user'

const {
  showSettings,
  fixedHeader,
  sidebarLogo,
  title,
  logo,
  loginCaptcha,
  tagsView,
  sidebarView
} = defaultSettings

const state = {
  theme: '',
  systemTitle: title,
  systemLogo: logo,
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  loginCaptcha: loginCaptcha,
  tagsView: tagsView,
  sidebarView: sidebarView,
  secureSettings: {},
  basicSettings: {},
  gisSettings: {}
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  GET_GLOBAL_SETTINGS: (state, { key, setting }) => {
    state[key] = setting
  },
  GET_SECURE_SETTINGS: (state, setting) => {
    state.secureSettings = setting
  },
  GET_BASIC_SETTINGS: (state, setting) => {
    state.basicSettings = setting
  }
}

// 安全设置
const getSecureSettings = ({ commit }) => {
  return new Promise((resolve, reject) => {
    secureView().then((res) => {
      commit('GET_SECURE_SETTINGS', res.data || {})
      resolve(res.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

// 基础配置
const getBasicSettings = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    basicView(params).then((res) => {
      commit('GET_BASIC_SETTINGS', res.data || {})
      resolve(res.data || {})
    }).catch((error) => {
      reject(error)
    })
  })
}

// 全局配置
const getGlobalSettings = ({ commit }, { type, key }) => {
  return new Promise((resolve, reject) => {
    view(type)
      .then((response) => {
        const { data } = response
        commit('GET_GLOBAL_SETTINGS', {
          key,
          setting: data || {}
        })
        resolve(data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const actions = {
  async changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  getSecureSettings,
  getBasicSettings,
  getGlobalSettings
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
